import React from 'react';
import Modal from './ui/Modal';
import Button from './ui/Button';

const DeleteUserModal = ({ isOpen, onClose, user, onConfirm, isDeleting }) => (
  <Modal isOpen={isOpen} onClose={isDeleting ? () => {} : onClose} title="Excluir usuário">
    <div className="space-y-5">
      <div className="rounded-lg border border-red-200 bg-red-50 p-4">
        <p className="font-semibold text-red-800">Esta ação é permanente.</p>
        <p className="mt-2 text-sm text-red-700">
          O perfil e os dados relacionados de <strong>{user?.name || user?.email}</strong> serão excluídos.
        </p>
      </div>

      <div className="text-sm text-gray-600">
        <p><strong>E-mail:</strong> {user?.email || 'Não informado'}</p>
        <p className="mt-1 break-all"><strong>UID:</strong> {user?.id}</p>
      </div>

      <p className="text-sm text-gray-700">
        Tem certeza de que deseja excluir este usuário?
      </p>

      <div className="flex gap-3 justify-end">
        <Button type="button" variant="secondary" onClick={onClose} disabled={isDeleting}>
          Cancelar
        </Button>
        <Button type="button" variant="danger" onClick={onConfirm} disabled={isDeleting}>
          {isDeleting ? 'Excluindo...' : 'Sim, excluir permanentemente'}
        </Button>
      </div>
    </div>
  </Modal>
);

export default DeleteUserModal;
